import React from "react";

const Kotlin_Data_Types = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Kotlin Data Types</h1>
      <p>Content for Kotlin Data Types goes here.</p>
    </div>
  );
};

export default Kotlin_Data_Types;
